var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0,
};

site.device = {
	// Check if device is a touch device
	isTouch: function () {
		try {
			document.createEvent('TouchEvent');
			return true;
		} catch (e) {
			return false;
		}
	},
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function (id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	},
};

site.slider = {
	init: function () {
		if ($('.lssSlider', '#main').length) {
			this.initSlider();
			this.initSteps();
			this.initCalculator();
		}
	},
	initSlider: function () {
		var $container = $('.lssSlider', '#main');

		$container.before('<div class="lssSlider__year"></div>');
		$container.slider({
			value: 60,
			min: 0,
			max: 120,
			step: 1,
			slide: function (event, ui) {
				site.slider.update($container, ui);
			},
		});

		site.slider.update($container);
	},
	initSteps: function () {
		var $container = $('.lssSlider', '#main'),
			values = site.slider.getValues(),
			steps = Object.keys(values),
			html = '';

		for (var i = 0; i < steps.length; i++) {
			html += '<span class="step">' + steps[i] + '</span>';
		}

		$container.after('<div class="lssSlider__steps">' + html + '</div>');
	},
	initCalculator: function () {
		var html = '<div class="lssSlider__input"><span class="label">Áætlaður lífeyrir miðað við 65 ára</span> <input type="text" id="money" value="100.000"> kr. á mánuði</div>'
			+ '<div class="lssSlider__start"><span class="label">Hefja töku lífeyris</span> <input type="text" id="startyear" value="65" maxlength="2"> ára  &nbsp;&nbsp; <input type="text" id="startmonth" value="1" maxlength="2"> mánaða</div>'
			+ '<div class="lssSlider__change"><span class="label">Prósentubreyting</span> <span class="change">0%</span> alls</div>'
			+ '<div class="lssSlider__total"><span class="label">Samtals</span> <span class="total">100.000</span> kr.</div>';

		$('.lssSlider__steps', '#main').after(html);

		$('#money').on('input', function () {
			var $this = $(this);
			$this.val(site.slider.numberFormat($this.val().replace(/\./g, ''), 0, ',', '.'));
			site.slider.update($('.lssSlider', '#main'));
		});

		$('#startyear').on('input', function () {
			var $this = $(this);
			if ($this.val() < 60) $this.val(60);
			if ($this.val() > 70) $this.val(70);
			site.slider.update($('.lssSlider', '#main'));
		});

		$('#startmonth').on('input', function () {
			var $this = $(this);
			if ($this.val() > 12) $this.val(12);
			site.slider.update($('.lssSlider', '#main'));
		});
	},
	update: function (slider, ui) {
		if (!ui) {
			ui = {value: slider.slider('value')};
		}

		var values = site.slider.getValues(),
			year = Math.floor((ui.value / 12) + 60),
			month = (ui.value % 12) + 1,
			percent = values[year][month],
			money = $('#money').val(),
			total = 0;

		if (money && month && year) {
			money = money.replace(/\./g, '', '');
			var sign = '';
			if (year < 65) { // Negative
				total = Math.round((1 - (percent / 100)) * money);
				sign = (percent > 0) ? '-' : '';
			}
			else { //positive
				total = Math.round(((percent / 100) + 1) * money);
				sign = (percent > 0) ? '+' : '';
			}

			total = site.slider.numberFormat(total, 0, ',', '.');

			$('.change', '.lssSlider__change').html(sign + percent + '%');
			$('.total', '.lssSlider__total').html(total);
			$('#startyear', '.lssSlider__start').val(year);
			$('#startmonth', '.lssSlider__start').val(month - 1);
		}
	},
	numberFormat: function (number, decimals, dec_point, thousands_sep) {
		number = (number + '')
			.replace(/[^0-9+\-Ee.]/g, '');
		var n = !isFinite(+number) ? 0 : +number,
			prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
			sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
			dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
			s = '',
			toFixedFix = function (n, prec) {
				var k = Math.pow(10, prec);
				return '' + (Math.round(n * k) / k)
					.toFixed(prec);
			};
		// Fix for IE parseFloat(0.55).toFixed(0) = 0;
		s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
			.split('.');
		if (s[0].length > 3) {
			s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
		}
		if ((s[1] || '')
			.length < prec) {
			s[1] = s[1] || '';
			s[1] += new Array(prec - s[1].length + 1)
				.join('0');
		}
		return s.join(dec);
	},
	getValues: function () {
		return {
			60: {
				1: '33',
				2: '32.55',
				3: '32.1',
				4: '31.65',
				5: '31.2',
				6: '30.75',
				7: '30.3',
				8: '29.85',
				9: '29.4',
				10: '28.95',
				11: '28.5',
				12: '28.1',
			},
			61: {
				1: '27.6',
				2: '27.1',
				3: '26.6',
				4: '26.1',
				5: '25.6',
				6: '25.1',
				7: '24.6',
				8: '24.1',
				9: '23.6',
				10: '23.1',
				11: '22.6',
				12: '22.1',
			},
			62: {
				1: '21.6',
				2: '21.05',
				3: '20.5',
				4: '19.95',
				5: '19.40',
				6: '18.85',
				7: '18.3',
				8: '17.75',
				9: '17.2',
				10: '16.65',
				11: '16.1',
				12: '15.6',
			},
			63: {
				1: '15',
				2: '14.4',
				3: '13.8',
				4: '13.2',
				5: '12.6',
				6: '12',
				7: '11.4',
				8: '10.8',
				9: '10.2',
				10: '9.6',
				11: '9',
				12: '8.4',
			},
			64: {
				1: '7.8',
				2: '7.15',
				3: '6.5',
				4: '5.85',
				5: '5.2',
				6: '4.55',
				7: '3.9',
				8: '3.25',
				9: '2.6',
				10: '1.95',
				11: '1.3',
				12: '0.65',
			},
			65: {
				1: '0',
				2: '0.6',
				3: '1.2',
				4: '1.8',
				5: '2.4',
				6: '3',
				7: '3.6',
				8: '4.2',
				9: '4.8',
				10: '5.4',
				11: '6',
				12: '6.6',
			},
			66: {
				1: '7.2',
				2: '7.85',
				3: '8.5',
				4: '9.15',
				5: '9.8',
				6: '10.45',
				7: '11.1',
				8: '11.75',
				9: '12.4',
				10: '13.05',
				11: '13.7',
				12: '14.35',
			},
			67: {
				1: '15',
				2: '15.71',
				3: '16.42',
				4: '17.13',
				5: '17.84',
				6: '18.55',
				7: '19.26',
				8: '19.97',
				9: '20.68',
				10: '21.39',
				11: '22.1',
				12: '22.81',
			},
			68: {
				1: '23.51',
				2: '24.3',
				3: '25.08',
				4: '25.86',
				5: '26.64',
				6: '27.42',
				7: '28.2',
				8: '28.98',
				9: '29.76',
				10: '30.54',
				11: '31.32',
				12: '32.1',
			},
			69: {
				1: '32.88',
				2: '33.74',
				3: '34.6',
				4: '35.46',
				5: '36.32',
				6: '37.18',
				7: '38.04',
				8: '38.9',
				9: '39.76',
				10: '40.62',
				11: '41.48',
				12: '42.34',
			},
			70: {1: '43.2'},
		};
	},
};

site.onepager = {
	init: function () {
		$('.section > .boxTitle', '#main').on('click', function () {
			$(this).parent('.section').toggleClass('open');
		});
	},
};

site.accessibility = {
	init: function () {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	},
};

site.faq = {
	init: function () {
		var $faq = $('#faq');
		if ($faq.length == 0) return false;

		$('.answer', $faq).each(function () {
			var $this = $(this);
			$this.css('max-height', $(this)[0].scrollHeight);
			if ($this.find('.mceWrap').length > 0) {
				$('.wrap', $this).addClass('hasMceWrap');
				$('>*:not(div)', $('.wrap', $this)).wrapAll('<div />');
			}
		});

		$(window).resize(function () {
			$('.answer', $faq).each(function () {
				$(this).css('max-height', $(this)[0].scrollHeight);
			});
		});

		$faq.find('.question').click(function () {
			$(this).parent('li').toggleClass('open');
		});
		$faq.find('#cancel').click(function () {
			window.history.back();
		});

		$('.slider', '#main').each(function () {
			$(this).find('.boxText > p').wrapAll('<div></div>');
		});


	},
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function () {
			var $img = $(this);
			$.get($img.attr('src'), function (data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function () {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	},
};

site.responsiveTables = {
	init: function () {
		this.wrap('#main, #sidebar');
	},

	wrap: function (selector) {
		$('table', selector).wrap('<div class="responsiveTable"></div>');
	},
};

site.frontpage = {
	init: function () {
		if ($('#front-banner ul li').length > 1) {
			site.owl.init('#front-banner ul', {
				loop: true,
				nav: true,
				dots: true,
				margin: 30,
				autoHeight: true,
				center: true,
				navText: ['', ''],
				items: 1,
				autoplay: false,
				autoplayTimeout: 9000,
				smartSpeed: 1000, // duration of change of 1 slide
			});
		}

		$(window).on('load', function () {
			if (moya.map.osmMap && $(window).width() > 768) {
				var offset = moya.map.osmMap.getSize().x * 0.15;
				moya.map.osmMap.panBy(new L.Point(-offset, 0));
			}
		});
	},
};

site.formbuilder = {
	init: function () {
		const form = document.querySelector('form.only_images');
		if (!form) {
			return;
		}
		form.querySelectorAll('input[type="file"]').forEach(fileElm => {
			fileElm.accept = '.jpg,.jpeg,.png';
			fileElm.addEventListener('change', function (event) {
				const file = event.target.files[0];
				const validMimeTypes = ['image/jpeg', 'image/png'];
				if (!validMimeTypes.includes(file.type)) {
					let notification = MoyaContainer.get('core.notification');
					const options = {
						'duration': 4000,
					};
					notification.warning('Vinsamlegast settu inn mynd.', options);
					event.target.value = '';
				}
			});
		});
	},
};


// Run all the inits \o/
$(function () {
	$.each(site.inits, function (i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.svg.init();
	site.labelFocus.init();
	site.slider.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}
	if ($body.is('.formbuilder')) {
		site.formbuilder.init();

	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function () {
		$(this).attr('allowfullscreen', '').wrap('<div class="video" style="max-width:' + $(this).width() + 'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
